export type Stat = {
  value: string
  label: string
}

export const latePaymentStats: Stat[] = [
  {
    value: '£50bn',
    label: 'Total value of overdue invoices for UK SMEs',
  },
  {
    value: '82%',
    label: 'UK SMEs have overdue invoices (YouGov poll)',
  },
  {
    value: '£6.1k',
    label: 'Average overdue invoice value for UK SMEs (FSB)',
  },
  {
    value: '48%',
    label: 'UK invoices are paid late (Xero & PayPal 2019)',
  },
  {
    value: '79%',
    label: 'SMEs don’t apply late payment charges (FSB)',
  },
  {
    value: '27%',
    label: 'UK SMEs have written off bad debt in the last 12 months',
  },
  {
    value: '£63k',
    label: 'Average value of all SME overdue invoices (YouGov)',
  },
  {
    value: '5%',
    label: 'UK SMEs have no cash reserves (ONS)',
  },
]

export type Solution = {
  eyebrow: string
  title: string
  description: string
}

export const solutions: Solution[] = [
  {
    eyebrow: 'Manage cash flow',
    title: 'Credit Control',
    description:
      'Get paid quickly with our award-winning tools, including automated invoice reminders, sending schedules and fully customisable templates for personalised messaging.',
  },
  {
    eyebrow: 'Understanding customers',
    title: 'Risk Insights',
    description:
      'Explore and monitor the health of your customers and suppliers through Risk Insights, with a complete view of key financial metrics and real-time alerts when circumstances change.',
  },
  {
    eyebrow: 'Close cash flow gaps',
    title: 'Selective Invoice Financing',
    description:
      'Access the UK’s most flexible invoice finance, which enables you to unlock working capital by borrowing against unpaid invoices. It’s fast, flexible and seamlessly interchangeable.',
  },
]

export type GettingStartedStep = {
  number: string
  title: string
  description: string
}

export const gettingStartedSteps: GettingStartedStep[] = [
  {
    number: '01',
    title: 'Connect your accounting package',
    description:
      'Credit Manager connects to all major accounting software packages. Select your provider and our system will guide you through the integration process.',
  },
  {
    number: '02',
    title: 'Complete your taskboard',
    description:
      'After completing your company details and connecting your accounting package, your Credit Manager task board will be updated with actions needed to complete your set up.',
  },
  {
    number: '03',
    title: 'Start controlling your cash flow',
    description:
      'You’re good to go. Start accessing complete cash flow management tools to support and grow your business.',
  },
]


